var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-header"},[_c('span',[_vm._v(_vm._s(_vm.UserTitle))]),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.HandleAdd}},[_vm._v("添加")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }